import { ColumnFiltersState } from '@tanstack/react-table';
import { useParams } from 'react-router-dom';

import { AccountTransactionsTab } from 'views/account/AccountTransactionsTab';
import { AccountTransactionsTable } from 'views/account/AccountTransactionsTable';

import { newAccountTransactionColumns, TRANSACTION_COLUMN_ORDER } from './transactions-columns';
import { useAccountPageView } from './useAccountPageView';

const INITIAL_FILTERS: Record<string, ColumnFiltersState> = {
    cash: [{ id: 'type', value: ['Deposits', 'Withdrawals'] }],
    transfers: [{ id: 'type', value: ['Transfer In', 'Transfer Out'] }],
};

export const AccountTransactionsRoute = () => {
    const { view } = useAccountPageView();
    const { transactionType = 'all' } = useParams<{ transactionType: string }>();
    return view === 'new' ? (
        <div className="pt-5">
            <AccountTransactionsTable
                key={transactionType}
                tableId="accountNewTransactionsAll"
                layout="new"
                columns={newAccountTransactionColumns}
                columnOrder={TRANSACTION_COLUMN_ORDER}
                initialColumnFilters={INITIAL_FILTERS[transactionType]}
            />
        </div>
    ) : (
        <AccountTransactionsTab />
    );
};
